import { ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router'
import { HasRoleGuard } from '@elderbyte/ngx-auth'
import { ElderAccessDeniedComponent } from '@elderbyte/ngx-starter'
import { WorkOrderDetailFullComponent } from './domain/orders/work-orders/work-order-detail-full/work-order-detail-full.component'
import { WorkOrderBrowserViewerComponent } from './domain/orders/work-orders/work-order-browser-viewer/work-order-browser-viewer.component'
import { ShopfloorLayoutComponent } from './domain/shopfloor/layout/shopfloor-layout/shopfloor-layout.component'
import { ProductionLineRouteBrowserComponent } from './domain/manufacturing/production-lines/production-line-route-browser/production-line-route-browser.component'
import { WorkCenterResolver } from './domain/shopfloor/workcenters/work-center-resolver.service'
import { WorkCenterDetailSideComponent } from './domain/shopfloor/workcenters/work-center-detail-side/work-center-detail-side.component'
import { CapabilitySpecDetailSideComponent } from './domain/process/capability-spec/capabilities/capability-spec-detail-side/capability-spec-detail-side.component'
import { CapabilitySpecResolver } from './domain/process/capability-spec/capability-spec-resolver.service'
import { WorkStationDetailSideComponent } from './domain/shopfloor/workstations/work-station-detail-side/work-station-detail-side.component'
import { WorkStationResolver } from './domain/shopfloor/workstations/work-station-resolver.service'
import { ControlCenterDetailSideComponent } from './domain/shopfloor/ccs/control-center-detail-side/control-center-detail-side.component'
import { ControlCenterResolver } from './domain/shopfloor/ccs/control-center-resolver.service'
import { ScheduleOverviewComponent } from './domain/orders/utilisation/facility/schedule-overview/schedule-overview.component'
import { ProcessPlanDetailSideComponent } from './domain/process/process-plans/production-plan-detail-side/process-plan-detail-side.component'
import { ProcessPlanResolver } from './domain/process/process-plans/process-plan-resolver.service'
import { WorkCenterTerminalComponent } from './domain/terminals/workcenter/work-center-terminal/work-center-terminal.component'
import { ControlTerminalResolver } from './domain/terminals/control-terminal-resolver.service'
import { ControlTerminalOrdersComponent } from './domain/terminals/workcenter/orders/terminal-orders/control-terminal-orders.component'
import { ControlTerminalBatchDetailComponent } from './domain/terminals/workcenter/orders/terminal-batch-detail/control-terminal-batch-detail.component'
import { ProdOrderBrowserViewerComponent } from './domain/orders/prod-orders/prod-order-browser-viewer/prod-order-browser-viewer.component'
import { ProdOrderComponent } from './domain/orders/prod-orders/detail/prod-order/prod-order.component'
import { ProcessPlanBrowserComponent } from './domain/process/process-plans/process-plan-browser/process-plan-browser.component'
import { ActionBrowserComponent } from './domain/process/actions/action-browser/action-browser.component'
import { TerminalOrderBatchesComponent } from './domain/terminals/workcenter/orders/terminal-order-batches/terminal-order-batches.component'
import { NumberSequenceDetailSideComponent } from './domain/sequencing/number/number-sequence-detail-side/number-sequence-detail-side.component'
import { NumberSequenceResolver } from './domain/sequencing/number/number-sequence-resolver.service'
import { WorkCenterTypeDetailSideComponent } from './domain/shopfloor/workcenters/types/work-center-type-detail-side/work-center-type-detail-side.component'
import { WorkCenterTypeResolver } from './domain/shopfloor/workcenters/types/work-center-type-resolver.service'
import { PropertyResolver } from './domain/properties/property-resolver.service'
import { ActionDetailSideComponent } from './domain/process/actions/action-detail-side/action-detail-side.component'
import { ActionResolver } from './domain/process/actions/action-resolver.service'
import { ControlTerminalComponent } from './domain/terminals/control-terminal/control-terminal/control-terminal.component'
import { StorageTerminalComponent } from './domain/terminals/storage/storage-terminal/storage-terminal.component'
import { ControlCenterViewerComponent } from './domain/shopfloor/ccs/control-center-viewer/control-center-viewer.component'
import { PropertyDetailSideComponent } from './domain/properties/property-detail-side/property-detail-side.component'
import { PackageTypeDetailSideComponent } from './domain/packages/types/package-type-detail-side/package-type-detail-side.component'
import { PackageTypeResolver } from './domain/packages/types/package-type-resolver.service'
import { WorkStationTypeDetailSideComponent } from './domain/shopfloor/workstations/types/work-station-type-detail-side/work-station-type-detail-side.component'
import { WorkStationTypeResolver } from './domain/shopfloor/workstations/types/work-station-type-resolver.service'
import { ProductionCodeDetailSideComponent } from './domain/production/codes/production-code-detail-side/production-code-detail-side.component'
import { ProductionCodeResolver } from './domain/production/codes/production-code-resolver.service'
import { DashboardComponent } from './domain/dashboard/dashboard.component'
import { MaterialDetailSideComponent } from './domain/materials/material-detail-side/material-detail-side.component'
import { MaterialResolver } from './domain/materials/material-resolver.service'
import { ReportDashboardComponent } from './domain/reports/report-dashboard/report-dashboard.component'
import { WorkCenterBrowserViewerComponent } from './domain/shopfloor/workcenters/work-center-browser-viewer/work-center-browser-viewer.component'
import { ProductionListViewerComponent } from './domain/production/lists/production-list-viewer/production-list-viewer.component'
import { ProductionListConfDetailSideComponent } from './domain/production/lists/conf/production-list-conf-detail-side/production-list-conf-detail-side.component'
import { ProdListConfResolver } from './domain/production/lists/conf/prod-list-conf-resolver.service'
import { BatchTracingSpecDetailSideComponent } from './domain/batchtracing/spec/batch-tracing-spec-detail-side/batch-tracing-spec-detail-side.component'
import { BatchTracingSpecResolver } from './domain/batchtracing/spec/batch-tracing-spec-resolver.service'
import { VendorDetailSideComponent } from './domain/batchtracing/vendors/vendor-detail-side/vendor-detail-side.component'
import { VendorResolver } from './domain/batchtracing/vendors/vendor-resolver.service'
import { TerminalGotoFirstActivator } from './domain/terminals/workcenter/terminal-goto-first-activator.service'
import { JsspSettingsSideDetailComponent } from './domain/jssp-settings/jssp-settings-side-detail/jssp-settings-side-detail.component'
import { JsspSettingsResolver } from './domain/jssp-settings/jssp-settings.resolver'
import { PropertyViewerComponent } from './domain/properties/property-viewer/property-viewer.component'
import { CapabilitySpecBrowserComponent } from './domain/process/capability-spec/capabilities/capability-spec-browser/capability-spec-browser.component'
import { WorkCenterTypeBrowserComponent } from './domain/shopfloor/workcenters/types/work-center-type-browser/work-center-type-browser.component'
import { WorkStationTypeBrowserComponent } from './domain/shopfloor/workstations/types/work-station-type-browser/work-station-type-browser.component'
import { PackageTypeBrowserComponent } from './domain/packages/types/package-type-browser/package-type-browser.component'
import { NumberSequenceBrowserComponent } from './domain/sequencing/number/number-sequence-browser/number-sequence-browser.component'
import { FacilityScheduleDetailComponent } from './domain/facilities/scheduling/facility-schedule-detail/facility-schedule-detail.component'
import { OptimisationSettingsContainerComponent } from './domain/optimisation/optimisation-settings-container/optimisation-settings-container.component'
import { ProductionCodeBrowserComponent } from './domain/production/codes/production-code-browser/production-code-browser.component'
import { ProductionListConfViewerComponent } from './domain/production/lists/conf/production-list-conf-viewer/production-list-conf-viewer.component'
import { MaterialBrowserComponent } from './domain/materials/material-browser/material-browser.component'
import { VendorBrowserComponent } from './domain/batchtracing/vendors/vendor-browser/vendor-browser.component'
import { BatchTracingSpecBrowserComponent } from './domain/batchtracing/spec/batch-tracing-spec-browser/batch-tracing-spec-browser.component'
import { CommandDispatcherComponent } from './domain/commands/command-dispatcher/command-dispatcher.component'
import { WorkStationBrowserViewerComponent } from './domain/shopfloor/workstations/work-station-browser-viewer/work-station-browser-viewer.component'
import { inject } from '@angular/core'
import { WorkItemDetailSideComponent } from './domain/orders/work-items/work-item-detail-side/work-item-detail-side.component'
import { workItemResolver } from './domain/orders/work-items/work-item.resolver'
import { SettingsComponent } from './domain/settings/settings.component'
import { JobsOverviewComponent } from './domain/jobs/jobs-overview/jobs-overview.component'

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'app/work-orders',
    pathMatch: 'full',
  },

  {
    path: 'app',
    children: [
      {
        path: '',
        redirectTo: 'work-orders',
        pathMatch: 'full',
      },
      {
        path: 'accessdenied',
        component: ElderAccessDeniedComponent,
      },

      {
        path: 'dashboard',
        canActivate: [HasRoleGuard],
        component: DashboardComponent,
        data: {
          roles: ['VIEWER'],
          title: 'context.overview',
        },
      },

      // Manufacturing
      {
        path: 'production-lines',
        canActivate: [HasRoleGuard],
        component: ProductionLineRouteBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'manufacturing.lines.title',
        },
      },

      // work-center-utilisation
      {
        path: 'scheduling',
        canActivate: [HasRoleGuard],
        component: ScheduleOverviewComponent,
        data: {
          roles: ['VIEWER'],
          title: 'manufacturing.scheduling.title',
        },
      },

      // Work Orders
      {
        path: 'work-orders',
        canActivate: [HasRoleGuard],
        component: WorkOrderBrowserViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.work.title',
        },
      },

      {
        path: 'work-orders/:orderId',
        canActivate: [HasRoleGuard],
        component: WorkOrderDetailFullComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.work.detail',
        },
      },

      // Prod Orders
      {
        path: 'prod-orders',
        canActivate: [HasRoleGuard],
        component: ProdOrderBrowserViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.prod.title',
        },
      },
      {
        path: 'prod-orders/:orderId',
        canActivate: [HasRoleGuard],
        component: ProdOrderComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.prod.detail',
        },
      },

      // WorkCenters
      {
        path: 'shop-floor/work-centers',
        canActivate: [HasRoleGuard],
        component: WorkCenterBrowserViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.workcenters.title',
        },
      },

      // WorkStations
      {
        path: 'shop-floor/work-stations',
        canActivate: [HasRoleGuard],
        component: WorkStationBrowserViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.workstations.title',
        },
      },

      // ControlCenters
      {
        path: 'shop-floor/control-centers',
        canActivate: [HasRoleGuard],
        component: ControlCenterViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.controlcenters.title',
        },
      },

      // Shopfloor Layout
      {
        path: 'shop-floor/layout',
        canActivate: [HasRoleGuard],
        component: ShopfloorLayoutComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.layout.title',
        },
      },

      // Process
      {
        path: 'process/plans',
        canActivate: [HasRoleGuard],
        component: ProcessPlanBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'process.plans.title',
        },
      },
      {
        path: 'process/actions',
        canActivate: [HasRoleGuard],
        component: ActionBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'process.actions.title',
        },
      },

      // Production list
      {
        path: 'production-list',
        canActivate: [HasRoleGuard],
        component: ProductionListViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.prod.list.title',
        },
      },

      // Reports
      {
        path: 'reports',
        canActivate: [HasRoleGuard],
        component: ReportDashboardComponent,
        data: {
          roles: ['VIEWER'],
          title: 'reports.title',
        },
      },

      // Jobs
      {
        path: 'jobs',
        canActivate: [HasRoleGuard],
        component: JobsOverviewComponent,
        data: {
          roles: ['SITE_MANAGER'],
          title: 'jobs.title',
        },
      },

      // Settings
      {
        path: 'settings/local',
        canActivate: [HasRoleGuard],
        component: SettingsComponent,
        data: {
          roles: ['VIEWER'],
          title: 'settings.local',
        },
      },
      {
        path: 'settings/properties',
        canActivate: [HasRoleGuard],
        component: PropertyViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'properties.title',
        },
      },
      {
        path: 'settings/capabilities',
        canActivate: [HasRoleGuard],
        component: CapabilitySpecBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'capabilities.capabilities',
        },
      },
      {
        path: 'settings/workcenter-types',
        canActivate: [HasRoleGuard],
        component: WorkCenterTypeBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.workcenters.types.types',
        },
      },
      {
        path: 'settings/workstation-types',
        canActivate: [HasRoleGuard],
        component: WorkStationTypeBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'shopfloor.workstations.types.types',
        },
      },
      {
        path: 'settings/package-types',
        canActivate: [HasRoleGuard],
        component: PackageTypeBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'packages.types.types',
        },
      },
      {
        path: 'settings/number-sequences',
        canActivate: [HasRoleGuard],
        component: NumberSequenceBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'numberSequences.title',
        },
      },
      {
        path: 'settings/work-schedules',
        canActivate: [HasRoleGuard],
        component: FacilityScheduleDetailComponent,
        data: {
          roles: ['VIEWER'],
          title: 'schedules.workSchedules',
        },
      },
      {
        path: 'settings/optimization',
        canActivate: [HasRoleGuard],
        component: OptimisationSettingsContainerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'optimization.title',
        },
      },
      {
        path: 'settings/production-codes',
        canActivate: [HasRoleGuard],
        component: ProductionCodeBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'production_codes.title',
        },
      },
      {
        path: 'settings/production-lists',
        canActivate: [HasRoleGuard],
        component: ProductionListConfViewerComponent,
        data: {
          roles: ['VIEWER'],
          title: 'orders.prod.list.lists',
        },
      },
      {
        path: 'settings/materials',
        canActivate: [HasRoleGuard],
        component: MaterialBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'materials.title',
        },
      },
      {
        path: 'settings/vendors',
        canActivate: [HasRoleGuard],
        component: VendorBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'manufacturer.title',
        },
      },
      {
        path: 'settings/batch-tracing',
        canActivate: [HasRoleGuard],
        component: BatchTracingSpecBrowserComponent,
        data: {
          roles: ['VIEWER'],
          title: 'batchtracing.title',
        },
      },
      {
        path: 'settings/commands',
        canActivate: [HasRoleGuard],
        component: CommandDispatcherComponent,
        data: {
          roles: ['OWNER'],
          title: 'commands.title',
        },
      },

      // Control Terminal
      {
        path: 'terminals/:terminalId', // accessa will route here, will implicitly redirect to /work-centers/workCenterId/orders
        canActivate: [HasRoleGuard],
        component: ControlTerminalComponent,
        resolve: {
          controlTerminal: ControlTerminalResolver,
        },
        runGuardsAndResolvers: 'always',
        data: {
          roles: ['VIEWER'],
          title: 'terminals.terminal',
          kioskMode: true,
        },
        children: [
          {
            canActivate: [
              (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>
                inject(TerminalGotoFirstActivator).canActivate(next, state),
            ],
            path: 'work-centers',
            component: WorkCenterTerminalComponent, // dummy, will redirect
          },
          {
            path: 'work-centers/:workCenterId',
            component: WorkCenterTerminalComponent,
            children: [
              {
                path: 'orders',
                component: ControlTerminalOrdersComponent,
              },
              {
                path: 'orders/:workOrderId',
                component: TerminalOrderBatchesComponent,
              },
              {
                path: 'orders/:workOrderId/batches/:workBatchId',
                component: ControlTerminalBatchDetailComponent,
              },
            ],
          },
          {
            path: 'storage',
            component: StorageTerminalComponent,
          },
        ],
      },
    ],
  },

  /// OUTLET SIDE

  // Number Sequences
  {
    path: 'number-sequences/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: NumberSequenceDetailSideComponent,
    resolve: {
      numberSequence: NumberSequenceResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Work centers
  {
    path: 'shop-floor/work-centers/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkCenterDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'shop-floor/work-centers/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkCenterDetailSideComponent,
    resolve: {
      workCenter: WorkCenterResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Work center types detail
  {
    path: 'work-centers/types/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkCenterTypeDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'work-centers/types/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkCenterTypeDetailSideComponent,
    resolve: {
      type: WorkCenterTypeResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Package types detail
  {
    path: 'packages/types/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: PackageTypeDetailSideComponent,
    data: {
      roles: ['SITE_MANAGER'],
    },
  },
  {
    path: 'packages/types/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: PackageTypeDetailSideComponent,
    resolve: {
      type: PackageTypeResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Property detail
  {
    path: 'properties/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: PropertyDetailSideComponent,
    resolve: {
      property: PropertyResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Vendor detail
  {
    path: 'vendors/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: VendorDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'vendors/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: VendorDetailSideComponent,
    resolve: {
      spec: VendorResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // BatchTracingSpec detail
  {
    path: 'batch-tracing-specs/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: BatchTracingSpecDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'batch-tracing-specs/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: BatchTracingSpecDetailSideComponent,
    resolve: {
      spec: BatchTracingSpecResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Capability Specs
  {
    path: 'capability-specs/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: CapabilitySpecDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'capability-specs/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: CapabilitySpecDetailSideComponent,
    resolve: {
      capability: CapabilitySpecResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'work-items/:itemId',
    outlet: 'side',
    component: WorkItemDetailSideComponent,
    canActivate: [HasRoleGuard],
    data: {
      roles: ['VIEWER'],
    },
    resolve: {
      workItem: workItemResolver,
    },
  },
  // Work stations
  {
    path: 'shop-floor/work-stations/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkStationDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'shop-floor/work-stations/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkStationDetailSideComponent,
    resolve: {
      workStation: WorkStationResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Work station types detail
  {
    path: 'work-stations/types/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkStationTypeDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'work-stations/types/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: WorkStationTypeDetailSideComponent,
    resolve: {
      type: WorkStationTypeResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Control centers
  {
    path: 'shop-floor/control-centers/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ControlCenterDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'shop-floor/control-centers/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ControlCenterDetailSideComponent,
    resolve: {
      controlCenter: ControlCenterResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Actions
  {
    path: 'process/actions/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ActionDetailSideComponent,
    data: {
      roles: ['VIEWER'],
      title: 'process.actions.new',
    },
  },
  {
    path: 'process/actions/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ActionDetailSideComponent,
    resolve: {
      action: ActionResolver,
    },
    data: {
      roles: ['VIEWER'],
      title: 'process.actions.action',
    },
  },

  // Process Plans
  {
    path: 'process-plans/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProcessPlanDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'process-plans/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProcessPlanDetailSideComponent,
    resolve: {
      processPlan: ProcessPlanResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Production Code detail
  {
    path: 'production-codes/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProductionCodeDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'production-codes/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProductionCodeDetailSideComponent,
    resolve: {
      prodCode: ProductionCodeResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Material detail
  {
    path: 'materials/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: MaterialDetailSideComponent,
    resolve: {
      material: MaterialResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },

  // Production List Configuration detail
  {
    path: 'prod-list-conf/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProductionListConfDetailSideComponent,
    data: {
      roles: ['VIEWER'],
    },
  },
  {
    path: 'prod-list-conf/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: ProductionListConfDetailSideComponent,
    resolve: {
      conf: ProdListConfResolver,
    },
    data: {
      roles: ['VIEWER'],
    },
  },
  // jssp settings
  {
    path: 'jssp-settings/new',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: JsspSettingsSideDetailComponent,
    data: {
      roles: ['SITE_MANAGER'],
    },
  },
  {
    path: 'jssp-settings/:id',
    outlet: 'side',
    canActivate: [HasRoleGuard],
    component: JsspSettingsSideDetailComponent,
    resolve: {
      jsspSettings: JsspSettingsResolver,
    },
    data: {
      roles: ['SITE_MANAGER'],
    },
  },
  {
    path: 'jobs/:id',
    outlet: 'side',
    loadComponent: () =>
      import('./domain/jobs/detail/job-detail-side/job-detail-side.component').then(
        (x) => x.JobDetailSideComponent
      ),
    canActivate: [HasRoleGuard],
    data: {
      roles: ['SITE_MANAGER'],
    },
  },
]
